import { getComponentCategoryList } from "@/api/feedback";
// 零部件类别
export const componentCategoryMap = new Map([
  ["zh", "nameZh"],
  ["en", "nameEn"],
  ["ru", "nameRu"],
  ["fa", "nameAr"],
  ["vi", "nameVi"],
  ["es", "nameEs"],
])
export async function getComponentCategoryData(vm) {
  if (!vm) {
    throw new Error("Vue 实例不能为空");
  }

  try {
    vm.componentCategoryName = componentCategoryMap;
    const response = await getComponentCategoryList();
    vm.componentCategoryList = response?.data || [];
    return vm.componentCategoryList;
  } catch (error) {
    console.error("获取组件分类数据失败:", error);
    vm.componentCategoryList = []; // 失败时设置为空数组
    throw error; // 可选择继续抛出或处理
  }
}